import { createToolbarButton } from '../../../../uScope/js/components/toolbar-button/toolbar-button-factory';
import {translate} from 'shared/services/I18nService';
import './toolbar-button.scss';

const BUTTON_CLASS = 'uscope-resize-button';
const BUTTON_HOVER_TEXT = 'uScope.extensions.resize-viewer.toolbar-icon-alt-text';

export const createButton = (uScope, onClick) => {
  // Create a button to add to uScope's toolbar.
  const button = createToolbarButton({
    className: BUTTON_CLASS,

    title: translate(BUTTON_HOVER_TEXT),

    onClick
  });

  uScope.topToolbar.addButton(button);
};



// WEBPACK FOOTER //
// ./src/vil/uScope-extensions/resize-viewer/toolbar-button/toolbar-button.js